routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    .state('home.serviceOrders', {
      url: "pagos-y-anticipos/ordenes-de-servicio",
      template: `<service-orders sh-ctrl="shCtrl"></service-orders>`
    });
}

export default routesConfig;



/** WEBPACK FOOTER **
 ** ./www/components/payments-advances/service-orders/service-orders.config.js
 **/